import { NoSsr } from '@cian/react-utils';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { EStatus } from '../../types/filters';
import { getDeletedDateString } from '../../utils/favoriteEntity';
import { Text } from '../Text';

interface IPublicationRemovalNoticeProps {
  status?: EStatus | null;
  deleteDate?: string | null;
  isMap?: boolean;
}

export const PublicationRemovalNotice: React.FC<IPublicationRemovalNoticeProps> = ({ status, deleteDate, isMap }) => {
  if (status && status !== EStatus.Published) {
    return (
      <div className={cn(styles['overlay'], isMap && styles['overlay--map'])} data-testid="status_text">
        <div className={styles['text']}>
          <Text bold>
            Объявление
            <br />
            снято с публикации
          </Text>
          {deleteDate && (
            <NoSsr>
              <Text textSize="small" color="black" data-testid="delete_date">
                Объявление
                <br />
                будет удалено из избранного {getDeletedDateString(deleteDate)}
              </Text>
            </NoSsr>
          )}
        </div>
      </div>
    );
  }

  return null;
};
